module.exports = __webpack_public_path__ + "img/first-place.2.3d8875b.png";